import { IXPSystem, XPConfigs } from "../interfaces/IXPSystem";
import { IXPModule } from "../interfaces/IXPModule";
import { IRulesDefinition } from "../interfaces/IRulesDefinition";
import { ActionResult } from "../interfaces/ActionResult";

export class XPSystem implements IXPSystem {
  xpModules: IXPModule[] = [];
  index: { [key: string]: number } = {};
  addKeyCallback: (key: string, update: boolean) => ActionResult;
  checkKeyDuplicateCallback: (key: string, update: boolean) => ActionResult;

  constructor(
    defaultRules: IRulesDefinition,
    addKeyCallback: (key: string, update: boolean) => ActionResult,
    checkKeyDuplicateCallback: (key: string, update: boolean) => ActionResult
  ) {
    this.addKeyCallback = addKeyCallback;
    this.checkKeyDuplicateCallback = checkKeyDuplicateCallback;
    if (defaultRules.xpModules) {
      defaultRules.xpModules.forEach((xpModule, i: number) => {
        this.xpModules.push(xpModule);
        this.addKeyCallback(xpModule.key, false);
      });
    }
  }

  public getXPConfigs = (): XPConfigs => {
    return this.xpModules.reduce((configs: XPConfigs, current: IXPModule) => {
      configs[current.key] = current.config;
      return configs;
    }, {});
  };
}
